/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsSubmitting/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function IsSubmitting({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/SubmittingInfo/IsSubmitting"
  
}) {
let dtLoadingbarBackgroundcolorPrimaryBackground = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LoadingBar.backgroundColor.primary.background'
        })
let dtLoadingbarBackgroundcolorPrimaryForeground = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LoadingBar.backgroundColor.primary.foreground'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 width="auto"
>
{childProps => (
<div
  data-testid="IsSubmitting.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 backgroundColorBackground={dtLoadingbarBackgroundcolorPrimaryBackground}
 backgroundColorForeground={dtLoadingbarBackgroundcolorPrimaryForeground}
 marginTop={0}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="Submitting your data"
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}